<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("staff module settings") }}
      </h1>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("drive module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_drive"
            name="chk_integrate_drive"
            v-model="meta.integrate_drive"
          />
          <label for="chk_integrate_drive">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('drive for photos')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/drive/catalog"
            name_field="name"
            value_field="drive_id"
            @selected="drive_changed"
            ref="drive_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="columns mt-5">
      <div class="column">
        <h1 class="title is-5">{{ $t("outbox module integration") }}</h1>
        <div class="field">
          <input
            class="is-checkradio"
            type="checkbox"
            id="chk_integrate_outbox"
            name="chk_integrate_outbox"
            v-model="meta.integrate_outbox"
          />
          <label for="chk_integrate_outbox">{{ $t("integrate") }}</label>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('warning notice template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="reception_template_changed"
            ref="reception_template_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('vacation request template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="vacation_request_template_changed"
            ref="vacation_request_template_dropdown"
          />
        </div>
      </div>
      <div class="column">
        <div class="field">
          <generic-dropdown
            :title="$t('payroll notification template')"
            :placeholder="$t('select one')"
            :is_multiple="false"
            url="/outbox/template/catalog"
            name_field="name"
            value_field="template_id"
            @selected="payroll_template_changed"
            ref="payroll_template_dropdown"
          />
        </div>
      </div>
    </div>

    <div class="container">
      <div
        class="button is-primary is-rounded is-pulled-right"
        @click="add_custom_field"
      >
        <span class="icon"><i class="fa fa-plus"></i></span>
        <span>{{ $t("add") }}</span>
      </div>
      <h1 class="title is-5 mt-5">{{ $t("custom fields") }}</h1>
    </div>
    <!-- <div class="grid is-col-min-12 mt-5"> -->
    <div class="container mt-5 pt-5">
      <div
        class=""
        v-for="(custom_field, cidx) in meta.custom_fields"
        :key="cidx"
      >
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label" v-if="cidx == 0">{{
                $t("field options")
              }}</label>
              <div class="control">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_field_quired_' + cidx"
                  :name="'chk_field_quired_' + cidx"
                  v-model="custom_field.required"
                />
                <label :for="'chk_field_quired_' + cidx">{{
                  $t("required")
                }}</label>
              </div>
              <div class="control">
                <input
                  class="is-checkradio"
                  type="checkbox"
                  :id="'chk_field_show_in_table' + cidx"
                  :name="'chk_field_show_in_table' + cidx"
                  v-model="custom_field.show_in_table"
                />
                <label :for="'chk_field_show_in_table' + cidx">{{
                  $t("show in table")
                }}</label>
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label" v-if="cidx == 0">{{ $t("name") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="custom_field.name" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label" v-if="cidx == 0">{{ $t("type") }}</label>
              <div class="control">
                <div class="select">
                  <select v-model="custom_field.type">
                    <option value="text">{{ $t("text") }}</option>
                    <option value="number">{{ $t("number") }}</option>
                    <option value="date">{{ $t("date") }}</option>
                    <option value="boolean">{{ $t("boolean") }}</option>
                    <option value="dropdown">{{ $t("dropdown") }}</option>
                    <option value="file">{{ $t("file") }}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="column" v-if="custom_field.type == 'dropdown'">
            <div class="field">
              <label class="label">{{ $t("options (coma separated)") }}</label>
              <div class="control">
                <input
                  class="input"
                  type="text"
                  v-model="custom_field.options"
                />
              </div>
            </div>
          </div>
          <div class="column">
            <label class="label" v-if="cidx == 0">{{ $t("options") }}</label>
            <div
              class="button is-danger is-rounded"
              @click="remove_custom_field(cidx)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
              <!-- <span>{{ $t("remove") }}</span> -->
            </div>
          </div>
        </div>
      </div>
      <!-- <pre>{{ meta.custom_fields }}</pre> -->
    </div>

    <div class="container mt-6">
      <status-datatable ref="status_datatable"></status-datatable>
    </div>

    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import StatusDatatable from ".//status_datatable/Index.vue";

export default {
  name: "StaffSettings",
  components: {
    GenericDropdown,
    GenericUploader,
    StatusDatatable,
  },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    drive_changed(value) {
      this.meta.drive_id = value.drive_id;
    },
    reception_template_changed(value) {
      this.meta.reception_template_id = value.template_id;
    },
    vacation_request_template_changed(value) {
      this.meta.vacation_request_template_id = value.template_id;
    },
    payroll_template_changed(value) {
      this.meta.payroll_template_id = value.template_id;
    },
    add_custom_field() {
      let v = this;
      if (!v.meta.custom_fields) v.meta.custom_fields = [];
      v.meta.custom_fields.push({
        name: "",
        type: "text",
        required: false,
      });
    },
    remove_custom_field(index) {
      let v = this;
      v.meta.custom_fields.splice(index, 1);
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.drive_id) v.$refs.drive_dropdown.set_value(conf.drive_id);

          if (conf.reception_template_id)
            v.$refs.reception_template_dropdown.set_value(
              conf.reception_template_id
            );

          if (conf.vacation_request_template_id)
            v.$refs.vacation_request_template_dropdown.set_value(
              conf.vacation_request_template_id
            );

          if (conf.payroll_template_id)
            v.$refs.payroll_template_dropdown.set_value(
              conf.payroll_template_id
            );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
